import React from "react";

import { RouteEnum } from "core/enum/route.enum";
import { IRoute } from "core/models/routes.model";

import { Login } from "components/Authentication/Login";
import { SigninOidc } from "components/Authentication/SigninOidc/SigninOidc";
import { SignOutOidc } from "components/Authentication/SignOutOidc/SignOutOidc";

import AboutUs from "screens/AboutUs/AboutUs";
import Cart from "screens/Cart";
import ContactUs from "screens/ContactUs/ContactUs";
import Landing from "screens/Landing/Landing";
import LibraryDetail from "screens/Library/LibraryDetail";
import LibraryList from "screens/Library/LibraryList";
import OrderDetails from "screens/Orders/OrderDetails";
import OrdersList from "screens/Orders/OrdersList";
import PaymentFailure from "screens/Payment/PaymentFailure";
import PaymentSuccess from "screens/Payment/PaymentSuccess";
import ProductDetails from "screens/ProductDetails";
import SiteRules from "screens/SiteRules/SiteRules";
import StatementDetail from "screens/Statement/StatementDetail";
import Statements from "screens/Statement/StatementList";
import Store from "screens/Store";
import Transaction from "screens/Transaction";

export const Routes: IRoute[] = [
  {
    path: RouteEnum.SignIn,
    component: <SigninOidc />,
    layout: "blank",
    auth: false,
  },
  {
    path: RouteEnum.SignOut,
    component: <SignOutOidc />,
    layout: "blank",
    auth: false,
  },
  {
    path: RouteEnum.Login,
    component: <Login />,
    layout: "blank",
    auth: false,
  },

  {
    path: RouteEnum.Landing,
    exact: true,
    component: <Landing />,
    layout: "main",
  },
  {
    path: RouteEnum.Store,
    exact: true,
    component: <Store />,
    layout: "main",
  },
  {
    path: RouteEnum.ContactUs,
    component: <ContactUs />,
    layout: "main",
  },
  {
    path: RouteEnum.AboutUs,
    component: <AboutUs />,
    layout: "main",
  },
  {
    path: RouteEnum.SiteRules,
    component: <SiteRules />,
    layout: "main",
  },
  {
    path: RouteEnum.Cart,
    component: <Cart />,
    layout: "main",
  },
  {
    path: RouteEnum.ProductDetails,
    exact: true,
    component: <ProductDetails />,
    layout: "main",
  },
  {
    path: RouteEnum.Transaction,
    component: <Transaction />,
    layout: "main",
    auth: true,
  },
  {
    path: RouteEnum.PaymentFailure,
    exact: true,
    component: <PaymentFailure />,
    layout: "main",
    auth: true,
  },
  {
    path: RouteEnum.PaymentSuccess,
    exact: true,
    component: <PaymentSuccess />,
    layout: "main",
    auth: true,
  },
  {
    path: RouteEnum.UserOrders,
    exact: true,
    component: <OrdersList />,
    layout: "main",
    auth: true,
  },
  {
    path: RouteEnum.UserOrderDetails,
    exact: true,
    component: <OrderDetails />,
    layout: "main",
    auth: true,
  },
  {
    path: RouteEnum.Library,
    exact: true,
    component: <LibraryList />,
    layout: "main",
  },
  {
    path: RouteEnum.LibraryDetail,
    exact: true,
    component: <LibraryDetail />,
    layout: "main",
  },
  {
    path: RouteEnum.Statements,
    component: <Statements />,
    layout: "main",
  },
  {
    path: RouteEnum.StatementDetail,
    component: <StatementDetail />,
    layout: "main",
  },
];
